import { DisputeTypes } from "../../../shared/constants";
import { FrontOfficeDisputes } from "./disputes";

export function FrontOfficePaymentFacilitatorDisputes() {
  return (
    <FrontOfficeDisputes
      disputeType={DisputeTypes.Frontoffice.PaymentFacilitatorDisputes}
    />
  );
}
